<template>
  <li 
    :class="[
      'list-inline-item', 
      'mb-2',
      { 'd-block w-100': depth > 0 } // Apply conditionally
    ]"
  >
    <span 
      class="badge border p-2 d-inline-flex align-items-center"
      :class="depth === 0 ? 'bg-light-primary' : 'bg-light-secondary'"
    >
      <button 
        v-if="category.isHaveChild" 
        @click="toggleExpand" 
        class="btn btn-xs p-0 border-0 me-1"
        :style="{ marginLeft: depth * 1.5 + 'rem' }"
      >
        <i :class="isExpanded ? 'ti ti-chevron-down' : 'ti ti-chevron-right'"></i>
      </button>
      <span v-else :style="{ marginLeft: depth * 1.5 + 1.5 + 'rem' }"></span> <!-- Indent non-expandable items -->
      
      {{ category.code }} - {{ category.name }}
      
      <button v-if="canEditMaterialCategories" @click="$emit('edit', category)" class="btn btn-xs ms-2 p-0 border-0">
        <i class="ti ti-pencil"></i>
      </button>
      <button v-if="canDeleteMaterialCategories" @click="$emit('delete', category)" class="btn btn-xs ms-1 p-0 border-0">
        <i class="ti ti-trash text-danger"></i>
      </button>
    </span>
    
    <ul v-if="isExpanded && category.children" class="list-inline mt-2">
      <CategoryListItem
        v-for="child in category.children"
        :key="child.id"
        :category="child"
        :depth="depth + 1"
        :can-edit-material-categories="canEditMaterialCategories"
        :can-delete-material-categories="canDeleteMaterialCategories"
        @edit="$emit('edit', $event)"
        @delete="$emit('delete', $event)"
        @expand="$emit('expand', $event)"
      />
    </ul>
  </li>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';

const props = defineProps({
  category: {
    type: Object,
    required: true
  },
  depth: {
    type: Number,
    default: 0
  },
  canEditMaterialCategories: {
    type: Boolean,
    default: false
  },
  canDeleteMaterialCategories: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['edit', 'delete', 'expand']);

// Internal state for expansion to avoid prop mutation
const isExpanded = ref(props.category.isExpanded || false); 

const toggleExpand = () => {
  isExpanded.value = !isExpanded.value;
  // Only emit expand event if children need loading (not already loaded)
  if (isExpanded.value && (!props.category.children || props.category.children.length === 0)) {
     emit('expand', { ...props.category, isExpanded: isExpanded.value });
  } else {
     // If collapsing or already loaded, just update local state
     // Optionally emit an event if parent needs to know about collapse
  }
};

// Ensure computed property reacts to prop changes if necessary
// This might be needed if parent component forces expansion state
// const isExpanded = computed({
//   get: () => localIsExpanded.value,
//   set: (val) => { localIsExpanded.value = val; }
// });

// Watch for external changes to category.isExpanded if needed
// watch(() => props.category.isExpanded, (newVal) => {
//   isExpanded.value = newVal;
// });

</script>

<style scoped>
.list-inline-item {
  /* Removed display: block; and width: 100%; */
  /* Root items will now flow inline within the flex container */
}

.list-inline {
  padding-left: 0; /* Remove default ul padding */
  list-style: none;
  /* width: 100%; Removed as d-block w-100 on li handles this for children */
}

.badge {
  font-size: 90%;
  white-space: normal; /* Allow text wrapping */
  text-align: left;
}

.badge button {
  background: transparent;
  flex-shrink: 0; /* Prevent buttons from shrinking */
}

.badge button:hover {
  opacity: 0.7;
}

.bg-light-primary {
  background-color: #e7f3ff !important; /* Slightly different bg for root */
  border-color: #cce1ff !important;
}

.bg-light-secondary {
  background-color: #f8f9fa !important;
  border-color: #e9ecef !important;
}
</style> 